import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPosPriorityChangeRequest } from '../models/models'
import { CommonPostResponse } from '../../../components/models/models'

export class ChangeMainPosApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransaction/changeMainPos',
      requesterInfo,
    })
  }

  public async changeMainPos(request: IPosPriorityChangeRequest): Promise<any> {
    return await this.postAsync<IPosPriorityChangeRequest>(request)
  }
}